module.exports = __webpack_public_path__ + "img/xiaolin-android.bdf32a61.png";